import { type Theme } from '@mui/material';
import makeStyles from '@mui/styles/makeStyles';

export const useStyles = makeStyles((theme: Theme) => ({
  container: {
    marginBottom: '30px',
    paddingLeft: '70px',
    paddingRight: '70px',
    [theme.breakpoints.down(800)]: {
      paddingLeft: '34px',
      paddingRight: '34px',
    },
    [theme.breakpoints.down(720)]: {
      marginBottom: '45px',
      paddingLeft: '20px',
      paddingRight: '20px',
    },
  },
  title: {
    textAlign: 'center',
    paddingTop: '96px',
    paddingBottom: '52px',
    fontSize: '44px',
    fontWeight: 700,
    lineHeight: '48px',
    letterSpacing: '-1px',
    [theme.breakpoints.down(800)]: {
      paddingTop: '48px',
      paddingBottom: '28px',
      fontSize: '28px',
      fontWeight: 700,
      lineHeight: '36px',
      letterSpacing: '-0.75px',
    },
  },
  projectsContainer: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'stretch',
    [theme.breakpoints.down(1200)]: {
      flexWrap: 'nowrap',
      justifyContent: 'flex-start',
      overflowX: 'scroll',
      overflowY: 'hidden',
      scrollBehavior: 'smooth',
      WebkitOverflowScrolling: 'touch',
      gap: '24px',
      paddingLeft: '24px',
      paddingRight: '24px',
      scrollbarWidth: 'none',
      '-ms-overflow-style': 'none',
      '&::-webkit-scrollbar': { display: 'none' },
      [theme.breakpoints.down(600)]: {
        paddingLeft: '16px',
        paddingRight: '16px',
      },
      [theme.breakpoints.down(400)]: {
        paddingLeft: '12px',
        paddingRight: '12px',
      },
    },
  },
  projectCard: {
    flex: '1 1 0',
    maxWidth: '350px',
    display: 'flex',
    [theme.breakpoints.down(1200)]: {
      minWidth: '280px',
      flexShrink: 0,
      [theme.breakpoints.down(600)]: {
        minWidth: '260px',
        maxWidth: '320px',
      },
      [theme.breakpoints.down(480)]: {
        minWidth: '220px',
        maxWidth: '280px',
      },
      [theme.breakpoints.down(400)]: {
        minWidth: '180px',
        maxWidth: '260px',
      },
    },
  },
  readMoreContainer: {
    display: 'flex',
    justifyContent: 'center',
    marginTop: '48px',
    marginBottom: '30px',
    [theme.breakpoints.down(900)]: {
      marginBottom: '0',
    },
    [theme.breakpoints.down(1200)]: {
      marginBottom: '0',
      marginTop: '24px',
    },
  },
}));
